<div class="login-container d-flex align-items-center justify-content-center min-vh-100">
  
  <div class="login-card d-flex rounded">
    <!-- Panel Izquierdo: Bienvenida -->
    <div class="left-panel d-flex flex-column justify-content-center align-items-center p-5 text-white">
      <img src="assets/img/brand/logo_jamar_rojo.svg" alt="Logo Jamar">
      <h1 class="fw-bold mb-2">¡Bienvenidos a NOVA!</h1>
      <p>La plataforma donde encontrarás todas las aplicaciones de nuestra organización de manera centralizada.</p>
      <p>NOVA (Núcleo Operativo de Valor Administrativo) </p>
    </div>

    <!-- Panel Derecho: Formulario -->
    <div class="right-panel p-5 bg-white">

      <div class="text-center mb-4">
        <h3 class="fw-bold">{{ TITLE }}</h3>
      </div>

      <form [formGroup]="form" (ngSubmit)="login($event)" class="form-container">
        <div class="custom-input mb-3">
            <input type="text" placeholder="Usuario"
                  formControlName="username"
                  maxlength="100"
                  (input)="onUsernameInput($event)"
                  required>
          </div>

        <div class="custom-input mb-3">
          <input [type]="hidePassword ? 'password' : 'text'" placeholder="Contraseña"
          formControlName="password"
          maxlength="100"
          required>

          <button type="button" class="icon-button" (click)="hidePassword = !hidePassword" aria-label="Mostrar/ocultar contraseña">
          <mat-icon class="input-icon">{{ hidePassword ? 'lock' : 'lock_open' }}</mat-icon>
          </button>
        </div>

        <div class="d-flex gap-2 justify-content-center mb-2 country">
          <button mat-icon-button type="button" (click)="changeConnection('JP')" matTooltip="Panamá" class="with-background"
            [ngClass]="{'active': form.value.c_emp === 'JP'}">
            <img src="https://static.abstractapi.com/country-flags/PA_flag.svg" />
          </button>
          <button mat-icon-button type="button" (click)="changeConnection('JA')" matTooltip="Colombia" class="with-background"
            [ngClass]="{'active': form.value.c_emp === 'JA'}">
            <img src="https://static.abstractapi.com/country-flags/CO_flag.svg" />
          </button>
        </div>

        <button mat-flat-button color="primary" type="submit" class="w-100 mt-2">
          Iniciar sesión
        </button>
      </form>

      <div class="text-center mt-3">
        <a [routerLink]="['../help']"><small>¿Necesitas ayuda para ingresar?</small></a>
      </div>

    </div>
  </div>
</div>
